import { Box, Stack, styled } from '@mui/material'
import { CustomContentProps, SnackbarContent } from 'notistack'
import { forwardRef } from 'react'

const Toast = forwardRef<HTMLDivElement, CustomContentProps>(
  ({ action, iconVariant, id, message, style, variant }, ref) => {
    return (
      <StyledSnackbarContent className={variant} ref={ref} style={style}>
        <Message>
          {iconVariant[variant]}

          <Stack alignItems="center" direction="row" whiteSpace="break-spaces">
            {message}
          </Stack>

          {/* @ts-ignore */}
          {action && <Box ml={1}>{action(id)}</Box>}
        </Message>
      </StyledSnackbarContent>
    )
  }
)

const StyledSnackbarContent = styled(SnackbarContent)(({ theme }) => ({
  ...theme.typography.body2,
  backgroundColor: theme.palette.grey[900],
  borderRadius: theme.shape.borderRadius,
  boxShadow:
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  padding: '6px 16px',

  '& b, & strong': {
    color: 'white',
  },

  '&.default': {
    backgroundColor: theme.palette.grey[900],
  },

  '&.error': {
    backgroundColor: theme.palette.error.dark,
  },

  '&.info': {
    backgroundColor: theme.palette.info.dark,
  },

  '&.success': {
    backgroundColor: theme.palette.success.dark,
  },

  '&.warning': {
    backgroundColor: theme.palette.warning.dark,
  },
}))

const Message = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 0),
}))

export default Toast
